// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1pEOw","filesListContainer":"PosDisputesFiles_filesListContainer__2YhQW","filesButton":"PosDisputesFiles_filesButton__3QpBm"};